import React, { useState, useEffect, useContext } from "react";
import { ProductContext } from "../../../../stores/session";
import GenericDataRow from "../../../../GenericPageElements/GenericDataRow";
import './SearchBar.scss'

export default function SearchBar({ loading, spid, setSpid, getWorkflowLast, _cur, workflowItems, getWorkflowNext }) {
    const { translations, isWorkflow } = useContext(ProductContext)
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (!isWorkflow) {
            setSearch('')
        }
    }, [isWorkflow])

    useEffect(() => {
        if (spid) {
            setSearch(spid);
        }
    }, [spid])

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            setSpid(search ? search : spid);
        }
    }

    return (
        <div className='search-container'>
            <GenericDataRow title={translations['SPID']} contentColour={'var(--white)'}
                style={{ display: 'grid', fontSize: '13px' }}
            >
                <input disabled={loading || isWorkflow}
                    className='search-input'
                    value={loading ? '' : search ?? spid}
                    onChange={e => setSearch(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                {loading && <i className="fa fa-spinner fa-spin loading-spinner" />}
                {
                    isWorkflow &&
                    <div className="workflow-navigation">
                        <span className='fas fa-angle-left colour-primary' style={{ cursor: 'pointer' }} onClick={getWorkflowLast}></span>
                        <span>{_cur + 1}/{workflowItems.length}</span>
                        <span className='fas fa-angle-right colour-primary' style={{ cursor: 'pointer' }} onClick={getWorkflowNext}></span>
                    </div>
                }
            </GenericDataRow>
            { !isWorkflow &&
                <button className="search-button" onClick={() => setSpid(search ? search : spid)}>
                    Search
                </button>
            }
        </div>
    )
}
